<template>
  <Teleport to="body">
    <Transition name="modal">
      <div class="modal-overlay" @click="close">
        <div class="auth-form" @click.stop>
          <RegisterSuccess
            v-if="showRegisterSuccess"
            @close="handleCloseRegisterSuccess"
          />

          <div v-else class="auth-form__content">
            <div class="auth-form__header">
              <h1 class="auth-form__title">Қош келдіңіз!</h1>
              <p class="auth-form__subtitle">Жүйеге қосылыңыз</p>
            </div>

            <div class="auth-form__tabs">
              <button
                v-for="tab in tabs"
                :key="tab.value"
                class="auth-form__tab"
                :class="{ 'auth-form__tab--active': tab.value === activeTab }"
                @click="activeTab = tab.value"
              >
                {{ tab.label }}
              </button>
            </div>

            <div class="auth-form__fields">
              <div class="auth-form__field">
                <input
                  v-model="usernameMasked"
                  v-maska:usernameUnmasked.unmasked="'+7 (###) ###-##-##'"
                  type="tel"
                  placeholder="+7 (___) ___-__-__"
                  class="auth-form__input"
                  maxlength="18"
                  @focus="onInputFocus"
                />
              </div>

              <template v-if="activeTab === 'register'">
                <div class="auth-form__field">
                  <input
                    v-model="form.full_name"
                    type="text"
                    placeholder="Аты жөні"
                    class="auth-form__input"
                  />
                </div>
                <div class="auth-form__field">
                  <input
                    v-model="form.email"
                    type="email"
                    placeholder="E-mail"
                    class="auth-form__input"
                  />
                </div>
              </template>
              <div class="auth-form__field">
                <input
                  v-model="form.password"
                  type="password"
                  placeholder="Құпия сөз"
                  class="auth-form__input"
                />
              </div>

              <div class="text-green-600 text-sm hover:underline">
                <a href="#">{{ $t("auth.forgotPassword") }}</a>
              </div>
            </div>

            <button
              v-loading="isLoading"
              :disabled="isLoading"
              @click="activeTab === 'login' ? login() : register()"
              class="auth-form__submit"
            >
              {{ buttonText }}{{ isLoading ? "..." : "" }}
            </button>
          </div>

          <button class="auth-form__close" @click="close">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M19.75 4.25L4.25 19.75M4.25 4.25L19.75 19.75"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import { authService } from "@/services/apiServices";
import { ElMessage } from "element-plus";
import { vMaska } from "maska/vue";
import RegisterSuccess from "@/components/RegisterSuccess.vue";

export default {
  name: "AuthForm",
  components: {
    RegisterSuccess,
  },
  directives: { maska: vMaska },
  props: {
    initialTab: {
      type: String,
      default: "login",
    },
  },
  data() {
    return {
      activeTab: this.initialTab,
      tabs: [
        {
          label: "Кіру",
          value: "login",
        },
        {
          label: "Тіркелу",
          value: "register",
        },
      ],

      usernameUnmasked: "",
      usernameMasked: "",
      form: {
        password: "",
        email: "",
        full_name: "",
      },
      isLoading: false,

      showRegisterSuccess: false,
    };
  },
  computed: {
    buttonText() {
      return this.activeTab === "login" ? "Кіру" : "Тіркелу";
    },
  },
  methods: {
    onInputFocus() {
      if (this.usernameMasked.length === 0) {
        this.usernameMasked = "+7 (";
      }
    },
    close() {
      this.$emit("closeAuthForm");
    },
    async login() {
      if (this.isLoading) return;

      if (this.usernameUnmasked.length !== 10) {
        ElMessage.error("Телефон нөмірін дұрыс енгізіңіз");
        return;
      }

      if (this.form.password.length < 6) {
        ElMessage.error("Құпия сөз 6 символдан кем болмауы тиіс");
        return;
      }

      this.isLoading = true;
      const error = await this.$store.dispatch("login", {
        username: "8" + this.usernameUnmasked,
        password: this.form.password,
      });
      this.isLoading = false;

      if (error) {
        ElMessage.error("Кіру сәтсіз аяқталды");
      } else {
        this.close();
        window.location.reload();
      }
    },
    async register() {
      if (this.isLoading) return;

      if (this.usernameUnmasked.length !== 10) {
        ElMessage.error("Телефон нөмірін дұрыс енгізіңіз");
        return;
      }

      if (this.form.full_name.length < 3) {
        ElMessage.error("Аты жөнін дұрыс енгізіңіз");
        return;
      }

      if (this.form.email.length < 3) {
        ElMessage.error("E-mail дұрыс енгізіңіз");
        return;
      }

      if (this.form.password.length < 6) {
        ElMessage.error("Құпия сөз 6 символдан кем болмауы тиіс");
        return;
      }

      try {
        this.isLoading = true;
        const response = await authService.register({
          ...this.form,
          username: "8" + this.usernameUnmasked,
        });
        console.log(response);
        if (response.responseStatus === 201) {
          this.showRegisterSuccess = true;
          this.form = {
            password: "",
            email: "",
            full_name: "",
          };
          this.usernameUnmasked = "";
          this.usernameMasked = "";
          // this.close();
        }
      } catch (error) {
        console.log(error);
        let errorMessage = "Тіркелу барысында қателер пайда болды";
        if (error.message) {
          errorMessage = error.message;
        }
        const errorData = error.response.data;
        if (errorData && typeof errorData === "object") {
          const errorKeys = Object.keys(errorData);
          if (errorKeys.length > 0) {
            const firstKey = errorKeys[0];
            if (Array.isArray(errorData[firstKey])) {
              errorMessage = errorData[firstKey][0];
            } else {
              errorMessage = errorData[firstKey];
            }
          }
        }

        ElMessage.error(errorMessage);
      } finally {
        this.isLoading = false;
      }
    },
    handleCloseRegisterSuccess() {
      this.showRegisterSuccess = false;
      this.activeTab = "login";
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  @apply fixed top-0 left-0 w-full h-full bg-black/50 flex justify-center items-center z-50;
}

.auth-form {
  @apply relative bg-white rounded-2xl p-6 max-w-[400px] w-full;
}

.auth-form__content {
  @apply flex flex-col gap-8;
}

.auth-form__header {
  @apply flex flex-col gap-1;
}

.auth-form__title {
  @apply text-xl font-semibold text-black;
}

.auth-form__subtitle {
  @apply text-base text-gray-500;
}

.auth-form__tabs {
  @apply flex gap-2 bg-gray-100 rounded-lg p-1;
}

.auth-form__tab {
  @apply flex-1 p-2 border-none bg-transparent rounded-lg text-sm text-black;
  cursor: pointer;
  &.auth-form__tab--active {
    @apply bg-[#FDC903] text-black;
  }
}

.auth-form__fields {
  @apply flex flex-col gap-4;
}

.auth-form__field {
  @apply w-full;
}

.auth-form__input {
  @apply w-full h-12 bg-gray-100 border-none rounded-lg p-4 text-base text-black;
}

.auth-form__input::placeholder {
  @apply text-gray-500;
}

.auth-form__submit {
  @apply w-full h-12 bg-[#058242] border-none rounded-lg text-white text-sm;
  cursor: pointer;
}

.auth-form__close {
  @apply absolute top-4 right-4 bg-transparent border-none p-0 cursor-pointer text-gray-500;
  &:hover {
    @apply text-gray-700;
  }

  svg {
    @apply w-5 h-5;
  }
}

/* Анимации */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-active .auth-form,
.modal-leave-active .auth-form {
  transition: transform 0.3s ease;
}

.modal-enter-from .auth-form,
.modal-leave-to .auth-form {
  transform: scale(0.95);
}
</style>
